<template>
  <svg
    :height="size"
    :width="size"
    viewBox="0 0 10 10"
    :fill="color"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <path
      d="M2.57955 2.1928L1.8125 1.43832L1.21165 2.03263L1.97443 2.78711L2.57955 2.1928ZM1.40341 4.57847H0.125V5.42146H1.40341V4.57847ZM5.23864 0.384583H4.38636V1.628H5.23864V0.384583V0.384583ZM8.41336 2.03263L7.8125 1.43832L7.04972 2.1928L7.65057 2.78711L8.41336 2.03263ZM7.04546 7.80713L7.80824 8.56582L8.40909 7.97151L7.64205 7.21704L7.04546 7.80713ZM8.22159 4.57847V5.42146H9.5V4.57847H8.22159ZM4.8125 2.47099C3.40199 2.47099 2.25568 3.60481 2.25568 4.99997C2.25568 6.39512 3.40199 7.52894 4.8125 7.52894C6.22301 7.52894 7.36932 6.39512 7.36932 4.99997C7.36932 3.60481 6.22301 2.47099 4.8125 2.47099ZM4.38636 9.61535H5.23864V8.37194H4.38636V9.61535ZM1.21165 7.9673L1.8125 8.56161L2.57528 7.80292L1.97443 7.20861L1.21165 7.9673Z"
    />
  </svg>
</template>

<script>
import { iconMixin } from '@/mixins/iconMixin'

export default {
  name: 'IconSun',
  ...iconMixin,
}
</script>
